export default "__VITE_ASSET__Cy7pu4WT__"